interface NoticePanelProps {
  title: string;
  children: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

export default function NoticePanel({
  title,
  children,
  actionLabel,
  onAction,
}: NoticePanelProps) {
  return (
    <div className="max-w-2xl rounded-lg border border-gray-200 bg-white p-6">
      <h2 className="text-base font-medium text-gray-900">{title}</h2>
      <p className="mt-2 text-sm text-gray-500">{children}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-4 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
